module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/rumble-02039bc2f57ab0225b52d4a8dbe7ff94.png";